export enum Page {
  LOG_IN = '/log-in',
  CREATE_INSPECTION = '/create-inspection',
  PHOTO_CAPTURE = '/photo-capture',
  DAMAGE_DISCLOSURE = '/damage-disclosure',
  VEHICLE_TYPE_SELECTION = '/vehicle-type-selection',
  CAPTURE_SELECTION = '/capture-selection',
}
